import { useState } from 'react';
import Logger from '../common/logger';
import { store } from '../store/store';
import { bookingApiSlice } from '../api/booking/bookingApiSlice';
import { DashboardDateRange, DashboardStatsResponse } from '../types/bookingCreation';
import { useDispatch } from 'react-redux';
import { setDashboardData, setDashboardDataFailed } from '../store/slices/globalSlice';

export const useGetDashboardData = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    return {
        isLoading,
        getDashboardData: async (data: DashboardDateRange): Promise<DashboardStatsResponse> => {
            setIsLoading(true);
            // store.dispatch(bookingApiSlice.util.invalidateTags(['dashboardData']));

            try {
                const results = await store
                    .dispatch(
                        bookingApiSlice.endpoints.getDashboardData.initiate({
                            data: {
                                from: data.from,
                                to: data.to,
                            },
                        }),
                    )
                    .unwrap();
                // A response without figures is a failure too, not a quiet
                // period (#2864).
                if (results.stats) {
                    dispatch(setDashboardData(results));
                } else {
                    dispatch(setDashboardDataFailed());
                }
                return results;
            } catch (error) {
                // Recorded, not swallowed (#2864): before, the catch never
                // dispatched, so Redux kept its all-zero initial figures and
                // the dashboard printed "0" and "0,00 €" for a failed request.
                Logger('getDashboardData').error(error);
                dispatch(setDashboardDataFailed());
                return error;
            } finally {
                setIsLoading(false);
            }
        },
    };
};
